import { useEffect, useState } from "react";
import { useSeo } from "@/hooks/useSeo";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";

export default function Privacy() {
  const [loaded, setLoaded] = useState(false);

  useSeo({
    title: "Политика конфиденциальности — Паруса на крыше",
    description: "Политика конфиденциальности ресторана Паруса на крыше. ООО «ДОБРО», ИНН 7813650216.",
    canonical: "/privacy",
  });
  useBreadcrumbs([{ name: "Политика конфиденциальности", path: "/privacy" }]);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 100);
  }, []);

  return (
    <div className="w-full min-h-screen bg-background relative z-10 pt-[120px] pb-32">
      <div className="container mx-auto px-6 md:px-14 max-w-4xl relative z-10">
        <div
          className="mb-16"
          style={{ opacity: loaded ? 1 : 0, transform: loaded ? "translateY(0)" : "translateY(20px)", transition: "all 0.8s ease 0.3s" }}
        >
          <h1 className="text-5xl md:text-6xl font-serif font-light text-primary mb-6 tracking-wide">
            Политика конфиденциальности
          </h1>
          <div className="w-24 h-[1px] bg-primary/30 mb-8"></div>
          <p className="text-muted-foreground text-sm tracking-wider">Последнее обновление: июнь 2026 г.</p>
        </div>

        <div
          className="space-y-12 text-foreground/80 font-light leading-relaxed"
          style={{ opacity: loaded ? 1 : 0, transform: loaded ? "translateY(0)" : "translateY(20px)", transition: "all 0.8s ease 0.5s" }}
        >
          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">1. Общие положения</h2>
            <p className="mb-4">
              Настоящая Политика конфиденциальности (далее — «Политика») регулирует порядок обработки персональных данных пользователей
              сайта ресторана «Паруса на крыше» (далее — «Сайт»), расположенного по адресу в сети Интернет.
            </p>
            <p className="mb-4">
              Оператором персональных данных является:
            </p>
            <div className="bg-card border border-primary/15 p-6 space-y-2 text-sm">
              <p><span className="text-muted-foreground tracking-wider text-[10px] uppercase">Организация:</span><br />ООО «ДОБРО»</p>
              <p><span className="text-muted-foreground tracking-wider text-[10px] uppercase">ИНН:</span><br />7813650216</p>
              <p><span className="text-muted-foreground tracking-wider text-[10px] uppercase">КПП:</span><br />781301001</p>
              <p><span className="text-muted-foreground tracking-wider text-[10px] uppercase">Юридический адрес:</span><br />197022, Санкт-Петербург, ул. Льва Толстого, 9, литер А</p>
              <p><span className="text-muted-foreground tracking-wider text-[10px] uppercase">Телефон:</span><br />8 (921) 270-06-48</p>
              <p><span className="text-muted-foreground tracking-wider text-[10px] uppercase">Генеральный директор:</span><br />Евдокимов Владислав Владимирович</p>
            </div>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">2. Какие данные мы собираем</h2>
            <p className="mb-4">При использовании Сайта и его сервисов (форма бронирования, форма обратной связи, онлайн-заявка на банкет) мы можем получать следующие данные:</p>
            <ul className="list-none space-y-2">
              {[
                "Имя и фамилия",
                "Номер телефона",
                "Адрес электронной почты",
                "Дата и время визита, количество гостей",
                "Комментарии и пожелания, добровольно оставленные в форме",
                "Технические данные: IP-адрес, тип браузера, страницы просмотра (через аналитику)"
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="text-primary mt-1 shrink-0">—</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">3. Цели обработки данных</h2>
            <p className="mb-4">Персональные данные обрабатываются исключительно в следующих целях:</p>
            <ul className="list-none space-y-2">
              {[
                "Обработка заявок на бронирование столиков и банкетных залов",
                "Обратная связь по запросам и вопросам гостей",
                "Информирование об акциях и мероприятиях (при наличии согласия)",
                "Улучшение качества сервиса и работы Сайта",
                "Исполнение требований законодательства Российской Федерации"
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="text-primary mt-1 shrink-0">—</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">4. Правовые основания</h2>
            <p className="mb-4">
              Обработка персональных данных осуществляется на основании Федерального закона от 27.07.2006 № 152-ФЗ
              «О персональных данных», а также на основании согласия субъекта персональных данных,
              выражаемого путём заполнения и отправки формы на Сайте.
            </p>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">5. Передача данных третьим лицам</h2>
            <p className="mb-4">
              Мы не продаём, не обмениваем и не передаём персональные данные третьим лицам, за исключением случаев:
            </p>
            <ul className="list-none space-y-2">
              {[
                "Исполнителей и подрядчиков, обеспечивающих работу Сайта и сервисов бронирования (в рамках договоров с обязательством конфиденциальности)",
                "Требований законодательства или судебных решений",
                "Защиты прав и законных интересов Оператора"
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="text-primary mt-1 shrink-0">—</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">6. Хранение и защита данных</h2>
            <p className="mb-4">
              Персональные данные хранятся не дольше, чем этого требуют цели их обработки, или в сроки,
              установленные законодательством РФ. Мы принимаем организационные и технические меры для
              защиты данных от несанкционированного доступа, изменения, раскрытия или уничтожения.
            </p>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">7. Права субъекта данных</h2>
            <p className="mb-4">Вы вправе:</p>
            <ul className="list-none space-y-2">
              {[
                "Получить информацию об обработке ваших персональных данных",
                "Потребовать уточнения, блокирования или уничтожения данных",
                "Отозвать согласие на обработку в любой момент",
                "Обратиться с жалобой в Роскомнадзор"
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="text-primary mt-1 shrink-0">—</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4">
              Для реализации прав обращайтесь по телефону{" "}
              <a href="tel:+79212700648" className="text-primary hover:text-accent transition-colors">8 (921) 270-06-48</a>{" "}
              или на электронную почту{" "}
              <a href="mailto:e@evdokimovgroup.ru" className="text-primary hover:text-accent transition-colors">e@evdokimovgroup.ru</a>.
            </p>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">8. Cookies и аналитика</h2>
            <p>
              Сайт может использовать файлы cookie и аналитические сервисы (Яндекс.Метрика и др.) для
              улучшения работы и анализа посещаемости. Продолжая использовать Сайт, вы соглашаетесь
              с использованием cookie. Вы можете отключить cookie в настройках браузера, однако это
              может повлиять на функциональность Сайта.
            </p>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">9. Изменения политики</h2>
            <p>
              Оператор вправе вносить изменения в настоящую Политику. Актуальная редакция всегда доступна
              на данной странице. Продолжение использования Сайта после внесения изменений означает
              согласие с новой редакцией.
            </p>
          </section>

          <section className="border-l border-primary/30 pl-8">
            <h2 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent uppercase mb-4">10. Контакты оператора</h2>
            <div className="space-y-1">
              <p>ООО «ДОБРО»</p>
              <p className="text-muted-foreground">197022, Санкт-Петербург, ул. Льва Толстого, 9, литер А</p>
              <p>
                <a href="tel:+79212700648" className="text-primary hover:text-accent transition-colors">8 (921) 270-06-48</a>
              </p>
              <p>
                <a href="mailto:e@evdokimovgroup.ru" className="text-primary hover:text-accent transition-colors">e@evdokimovgroup.ru</a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
